module.exports = __webpack_public_path__ + "redo.7678acc0b282f708ee87ca82fb7a6029.svg";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/img/redo.svg
// module id = 1660
// module chunks = 39